export enum CoreTooltipPlacement {
  AUTOSTART = 'auto-start',
  AUTO = 'auto',
  AUTOEND = 'auto-end',
  TOPSTART = 'top-start',
  TOP = 'top',
  TOPEND = 'top-end',
  RIGHTSTART = 'right-start',
  RIGHT = 'right',
  RIGHTEND = 'right-end',
  BOTTOMSTART = 'bottom-start',
  BOTTOM = 'bottom',
  BOTTOMEND = 'bottom-end',
  LEFTSTART = 'left-start',
  LEFT = 'left',
  LEFTEND = 'left-end',
}
